module.exports = __webpack_public_path__ + "static/media/writing-pending.3ba462b3.svg";